import React from 'react'

interface Props {
  size: number
  color: string
}

const path = `M121.663 70.3356C121.663 102.129 95.7962 128 64.0014 128C32.2057 128 6.33691 102.129 6.33691 70.3356C6.33691 46.647 21.1969 25.0177 43.3095 16.5144C46.9953 15.1014 51.1315 16.9343 52.5488 20.6205C53.9652 24.3055 52.1266 28.4415 48.4428 29.8588C31.808 36.2548 20.6338 52.5222 20.6338 70.3373C20.6338 94.2489 40.0875 113.702 64.0014 113.702C87.9147 113.702 107.367 94.2489 107.367 70.3373C107.367 52.9654 97.0378 37.3129 81.0623 30.4661C77.4323 28.9122 75.7491 24.7102 77.307 21.0815C78.8593 17.4533 83.0588 15.7709 86.689 17.3263C107.933 26.4271 121.663 47.2348 121.663 70.3356ZM64.6658 65.0458C68.6142 65.0458 71.8142 61.8463 71.8142 57.8974V7.14819C71.8142 3.20005 68.6142 0 64.6658 0C60.7192 0 57.5176 3.20005 57.5176 7.14819V57.8974C57.5176 61.8466 60.7204 65.0458 64.6658 65.0458Z`

const PowerIcon = ({ size, color }: Props) => (
  <svg width={size} height={size} viewBox='0 0 128 128' fill='none'>
    <path d={path} fill={color} />
  </svg>
)

export default PowerIcon
